import React from 'react'

import TextInput from '../../../../../../common/inputs/textInput/TextInput'
import { GenericDistanceToFieldProps } from '../../../../../../../@types/props-types'

const GenericDistanceToField: React.FC<GenericDistanceToFieldProps> = ({
  fieldValue,
  errors,
  id,
  fieldName,
  screenName,
  label,
  requiresMargin,
  onChange,
  onFocus,
  onBlur,
  maxLength = 2,
}) => (
  <div className={`grid-item ${requiresMargin ? 'margin-top-l' : ''}`}>
    <TextInput
      id={id}
      label={<span>{label}</span>}
      propertyName={fieldName}
      placeholder=''
      value={fieldValue}
      type='text'
      affixRight='unit'
      unitRight='minutes'
      maxLength={maxLength}
      errors={errors}
      doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
      onBlur={onBlur}
      onFocus={onFocus}
    />
  </div>
)

export default GenericDistanceToField
